import ApiService from '../apiservice'

export default class FaseService extends ApiService {
  constructor() {
    super('/fase')
  }

  cadastrar(fase) {
    return this.post('/',fase);
  }

  listar(empresa) {
    return this.get(`/${empresa}`);
  }

  consultar(codigo) {
    return this.get(`/porCodigo/${codigo}`);
  }

  alterar(fase) {
    return this.put(`/${fase.codigo}`,fase);
  }

  excluir(codigo) {
    return this.delete(`/${codigo}`);
  }
}